<template>
  <div class="form-outline pa-3">
    <form-legend :field="field" />
    <v-checkbox
      v-for="(checkbox, index) in fieldOptions.options"
      :key="'cb-' + checkbox.label + '-' + index"
      v-model="fieldValue[checkbox.label]"
      :label="checkbox.label"
      :readonly="readonly"
      dense
      color="primary-action-fg"
      @change="formUpdated"
    >
      <template v-slot:label>
        <div v-html="checkbox.label" />
      </template>
    </v-checkbox>

    <v-input :rules="rules" :hint="fieldOptions.description" persistent-hint v-bind="darkOrLightMode">
      <div v-if="hasOtherOption" style="display: flex">
        <v-checkbox color="primary-action" :key="'cb-Anderes-' + field.cid" v-model="fieldValue['Anderes']" :label="$t('other')" dense :readonly="readonly" />
        <v-text-field
          v-if="otherOptionIsSelected"
          v-model="otherValue"
          class="ml-4"
          :rules="getFieldRules({ required: otherOptionIsSelected })"
          :readonly="readonly"
          style="transform: translateY(-12px)"
          autofocus
          clearable
          color="primary-action"
        />
      </div>

      <template v-slot:message="{ message }">
        <legend v-html="message" />
      </template>
    </v-input>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : {},
      otherValue: this.formModel[this.field.cid + '_anderes'] ? this.formModel[this.field.cid + '_anderes'] : '',
    };
  },
  computed: {
    hasOtherOption() {
      return this.fieldOptions.include_other_option;
    },
    otherOptionIsSelected() {
      return this.fieldValue && 'Anderes' in this.fieldValue && this.fieldValue['Anderes'] === true;
    },
    fieldOptions() {
      return this.field && this.field.field_options ? this.field.field_options : { options: [] };
    },
    rules() {
      return [this.validateOtherField(), this.validateRequired()];
    },
  },
  methods: {
    formUpdated() {
      this.$emit('formUpdated', this.field.cid, this.fieldValue);
    },
    validateOtherField() {
      if (this.hasOtherOption && this.otherOptionIsSelected) {
        const field = this.formModel[this.field.cid + '_anderes'];
        return (field && field.length > 0) || this.$t('field.required');
      }
      return true;
    },
    validateRequired() {
      console.debug('validateRequired');
      if (this.field.required) {
        const cb = this.fieldValue;
        return cb ? Object.keys(cb).filter((k) => cb[k] === true).length > 0 || this.$t('field.required') : false;
      } else {
        return true;
      }
    },
  },
  watch: {
    fieldValue(newValue) {
      this.$emit('formUpdated', this.field.cid, newValue);
      if (!this.otherOptionIsSelected) {
        this.otherValue = '';
      }
    },
    otherValue(newValue) {
      this.$emit('formUpdated', this.field.cid + '_anderes', newValue);
    },
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
